var cov_10lrnc0j6c = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/context.tsx",
      hash = "8c5bd60a5e41bc5334eda4431674feb853f44cde",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/context.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import createContext from '../context';
export default createContext({});